// Angular Import
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  ViewChild, Renderer2
} from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
// React Imports
import { BehaviorSubject } from 'rxjs';
import { DealsModel } from 'src/app/models/main/deals/deals.model';
import { DealsService } from 'src/app/services/deals.service';
import { SearchModel } from 'src/app/models/main/deals/search.model';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CarouselComponent  } from 'ngx-owl-carousel-o';

@Component({
    selector: 'app-featured-deals',
    templateUrl: './featured-deals.component.html',
    styleUrls: ['./featured-deals.component.scss'],
    standalone: false, 
})
export class FeaturedDealsComponent implements OnInit, OnDestroy {
  @ViewChild('owlCarousel') owlCarousel: CarouselComponent;
  public title: string;
  facebook: string;
  twitter: string;
  linkedin: string;
  email : string;
  whatsapp : string;
  break : string;
  locationsArray: DealsModel[] = [];
  Search: SearchModel = new SearchModel();
  @Input() FilterData: BehaviorSubject<DealsModel[] | undefined> = new BehaviorSubject<DealsModel[] | undefined>(undefined);
  customOptions: OwlOptions = {
    nav: false, //if this is true, then default buttons are shown
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    autoWidth:true,
    margin:20,
    dots: false,
    navSpeed: 700,
    autoHeight: true,
    center: false,
    startPosition: 0,
    items: 1,
    responsive: {
        0: {
          items: 1
        },
        740: {
          items: 3
        },
        940: {
          items: 3
        },
        1024: {
          items: 3
        },
        1400: {
          items: 3 
        }
    },
    lazyLoad: true
  };
Math: any;

  prevSlide() {
    this.owlCarousel.prev();
  }

  nextSlide() {
    this.owlCarousel.next();
  }

constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private data: DealsService,
    private renderer:Renderer2
  ) {}

  public ngOnInit() : void {
    
    this.searchNew();
    this.facebook = "https://www.facebook.com/sharer/sharer.php?u=southafrica.net/za/en/";
    this.twitter = "https://x.com/intent/tweet?text=" + window.location.href + " " + " -";
    this.linkedin = "http://www.linkedin.com/shareArticle?mini=true&url=" + window.location.href;
    this.whatsapp = "https://wa.me/?text=" + window.location.href;
    this.email = window.location.href;
    this.break = "-"
  }

  /*search()
  {
    this.locationsArray = this.data.getAllFilter(this.Search);
    for (let i of this.locationsArray) {
      if(i.cf_images[0]?.mx_image.includes("(")){
        i.cf_images[0].mx_image = "assets/images/image.png";
      }
    }
  }
  */

  searchNew()
  {
    this.FilterData.subscribe(result => {
    if (!result) return;
  
    this.locationsArray = result
      .filter(item => {
      const price = Number(item.cf_newPrice) || 0;
      return price < 5000;
      })
      .filter(item => item !== undefined && item.cf_images && item.cf_images[0])
      .sort((x, y) => {
        const dateX = Number(x.date_deal_approved) * 1000;
        const dateY = Number(y.date_deal_approved) * 1000;
        return dateY - dateX; // Descending order
      });
      // Process each location
      this.locationsArray.forEach(location => {
        const image = location.cf_images[0];
       
        // Handle empty image case first
        if (!image.mx_image || image.mx_image.trim() === "") {
          image.mx_image = "assets/images/image.png";
          return;
        }

        // Escape parentheses if not already escaped
        if (image.mx_image.includes("(") && !image.mx_image.includes("\\")) {
          image.mx_image = image.mx_image.replace(/\(/g, '\\(').replace(/\)/g, '\\)');
        }

        // Encode spaces for URL safety
        if (image.mx_image.includes(" ")) {
          image.mx_image = image.mx_image.replace(/\s/g, '%20');
        }
  });
});
    
    
  }
  goToDeals(deal: string){
    
    sessionStorage.setItem('dealId', deal);
    window.location.href = "/deals/"+deal.replace(' ', '-').toLowerCase();
    
  }
  public ngOnDestroy() : void {
   
  }
}
